/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

// O que o usuário decidiu NESTA submissão sobre a forma de pagamento — não o
// que a tela está exibindo. Se a etapa atual não permite escolher a forma de
// pagamento, é `Manter`: o backend preserva o que já estava salvo.
export enum AcaoFormaPagamento {
  Manter = 0,
  DefinirPadrao = 1,
  DefinirPersonalizada = 2,
}

interface Props {
  idLeadCorretor?: string;
  idUnidade?: string;
  idOportunidade?: string | null;
  acaoFormaPagamento?: AcaoFormaPagamento;
  percentualDesconto?: string;
  percentualProSoluto?: string;
  valorAnual?: string;
  valorRenda?: string;
  percentualComprometimentoPico?: string;
  rendaEnquadrada?: boolean;
  avaliacaoConsiderada?: number | null;
  valorAvaliacao?: number | null;
}

export function useValidarProposta() {
  function toNumber(valor: any) {
    if (typeof valor === "number") return valor;
    if (typeof valor !== "string") return 0;

    const valorFormatado = valor.replace(/\./g, "").replace(",", ".");
    const numero = parseFloat(valorFormatado);

    return Number.isNaN(numero) ? 0 : numero;
  }

  const postData = async (props: Props) => {
    const VALIDAR_PROPOSTA = `${backofficeEnviroment}/common/oportunidades-lead/validar-proposta/vivaz/v1`;
    const { data } = await instance.post(VALIDAR_PROPOSTA, {
      idLeadCorretor: props.idLeadCorretor,
      idUnidade: props.idUnidade,
      // Backend usa para decidir se a validação também é persistida. `null`
      // quando a proposta ainda não existe (fluxo de nova simulação).
      idOportunidade: props.idOportunidade ?? null,
      // `Manter` no default: sem sinal explícito do usuário nesta submissão
      // (caso do F5, ou de salvar outro campo), o backend preserva a forma de
      // pagamento já salva em vez de assumir "padrão".
      acaoFormaPagamento: props.acaoFormaPagamento ?? AcaoFormaPagamento.Manter,
      percentualDesconto: toNumber(props.percentualDesconto),
      percentualProSoluto: toNumber(props.percentualProSoluto),
      valorAnual: toNumber(props.valorAnual),
      valorRenda: toNumber(props.valorRenda),
      percentualComprometimentoPico: toNumber(
        props.percentualComprometimentoPico
      ),
      rendaEnquadrada: props.rendaEnquadrada ?? false,
      // Vêm da resposta de resumo-pagamento; `null` enquanto ela não chegou,
      // para não afirmarmos um 0 que o backend leria como avaliação real.
      avaliacaoConsiderada: props.avaliacaoConsiderada ?? null,
      valorAvaliacao: props.valorAvaliacao ?? null,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onError: (error: any) => {
      notificarErroApi("Erro ao validar a proposta", error);
    },
  });

  return mutation;
}
